<template>
    <div class="marketing-box">
        <div class="marquee-text">
            <p class="toptext" v-if='marketingData.textData[0]'>{{marketingData.textData[0]}}</p>
            <p class="bottomtext" v-if='marketingData.textData[1]'>{{marketingData.textData[1]}}</p>
        </div>
        <!-- 文字内容区域 -->
        <div class="text-box" ref='textBox'>
            <div class="left-box">
                <!-- 行走的线 -->
                <div class="animetionLine"></div>
                <div class="left-center-box">
                    <div class="title">{{marketingData.title}}</div>
                    <h3 class="caption">{{marketingData.caption}}<span
                            class="showdown">{{marketingData.showdown}}</span></h3>
                    <div class="chinese-box" v-html='marketingData.chinese'></div>
                    <div class="english-box" v-html='marketingData.english' v-if='marketingData.english'></div>
                </div>
            </div>
            <div class="right-box" @click='toPath(marketingData.url)'></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Marketing',
        props: {
            marketingData: Object
        },
        data() {
            return {

            }
        },
        methods: {
            toPath(url) {
                window.location.href = url
            }
        }
    }
</script>
<style scoped>
    .marketing-box {
        overflow: hidden;
        position: relative;
        height: 782px;
    }

    .marquee-text {
        padding-top: 151px;
        position: relative;
        /* z-index: 2; */
    }

    .marquee-text p {
        font-size: 150px;
        font-weight: bold;
        line-height: 181px;
        white-space: nowrap;
        font-family: gilroybold4;
    }

    .marquee-text>p:first-child {
        color: #E5E5E5;
        margin-bottom: 15px;
        line-height: 220px;
        animation: topToright 40s linear infinite;
    }

    .bottomtext {
        color: #F1F1F1;
        font-size: 150px;
        font-weight: bold;
        line-height: 181px;
        -webkit-text-stroke: 2px #E4E4E4;
        text-stroke: 2px #E4E4E4;
        animation: bottomToright 40s linear infinite;
    }

    .showdown {
        font-family: gilroybold4;
    }

    /* 跑马灯字幕 */
    @keyframes topToright {
        0% {
            transform: translateX(100%);
        }

        25% {
            transform: translateX(0%);
        }

        50% {
            transform: translateX(-25%);
        }

        75% {
            transform: translateX(-50%);
        }

        100% {
            transform: translateX(-100%);
        }
    }

    @keyframes bottomToright {
        from {
            transform: translateX(100%);
        }

        to {
            transform: translateX(-100%);
        }
    }

    .text-box {
        width: 1201px;
        height: 782px;
        display: grid;
        grid-template-columns: 1061px 1fr;
        position: absolute;
        left: 0;
        bottom: 0;
        background-color: #ffffff;
        transition: all 0.5s;
    }

    .text-box:hover .right-box::after {
        letter-spacing: 10px;
        transform: rotate(-90deg) translateY(-100%);
    }

    .text-box:hover .right-box::before {
        width: 0%;
    }

    .left-box {
        padding: 74px 66px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: #ffffff;
    }

    .left-box::before {
        content: 'Blue  Whale';
        display: block;
        color: #E5E5E5;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        transform: rotate(90deg);
        position: absolute;
        top: 124px;
        left: 30px;
    }

    .left-center-box {
        max-width: 558px;
    }

    .right-box {
        background-color: #1C1C1C;
        position: relative;
    }

    .right-box::after {
        content: 'MORE';
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 35%;
        color: #ffffff;
        font-size: 16px;
        font-weight: 400;
        transform: rotate(-90deg);
        z-index: 3;
        transition: all 0.5s;
    }

    .right-box::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        background-color: #1C2015;
        opacity: 0.9;
        transition: all 0.5s;
        z-index: 2;
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        line-height: 137.5%;
        color: rgba(36, 136, 248, 1);
    }

    .caption {
        font-size: 64px;
        font-weight: 500;
        line-height: 75px;
        color: rgba(51, 51, 51, 1);
        margin: 16px 0 62px 0;
    }

    .showdown {
        font-size: 64px;
        font-weight: 400;
        line-height: 64px;
        color: #ffffff;
        -webkit-text-stroke: 2px rgba(112, 112, 112, 1);
        text-stroke: 2px rgba(112, 112, 112, 1);
        padding-left: 15px;
    }

    .chinese-box>>>p {
        font-size: 16px;
        font-weight: bold;
        line-height: 40px;
        color: rgba(102, 102, 102, 1);
    }

    .english-box {
        margin-top: 38px;
    }

    .english-box>>>p {
        font-size: 16px;
        font-weight: 400;
        line-height: 30px;
        color: rgba(153, 153, 153, 1);
    }

    .animetionLine {
        width: 46px;
        height: 14px;
        position: absolute;
        top: 210px;
        left: 50px;
        transform: rotate(90deg);
        overflow: hidden;
        /* background-color:red; */
    }

    .animetionLine::after {
        content: '';
        display: block;
        transform: rotate(90deg);
        width: 1px;
        height: 46px;
        background-color: #E5E5E5;
        position: absolute;
        top: -110%;
        right: 50%;
        animation: linearMotion 2.5s infinite;
    }

    .masking-box {
        width: 1071px;
        height: 759px;
        color: #F1F1F1;
        background-color: #000000;
        opacity: 0.3;
        transform: rotate(90deg) translateX(40%);
        font-size: 230px;
        font-weight: 500;
        text-transform: uppercase;
        position: absolute;
        display: flex;
        align-items: flex-end;
        padding-left: 130px;
        top: 0px;
        left: 50px;
        /* transform: translateY(-50%); */
        transition: all 0.5s;
    }

    .toDown {
        position: absolute;
        bottom: -20px;
        left: 87px;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: rotate(90deg);
    }

    .toDown::before {
        content: '';
        display: block;
        width: 90px;
        height: 1px;
        background-color: #707070;
        border: none;
        margin-right: 33px;
    }

    .toDown .icon-jiantou1 {
        font-size: 25px;
        font-weight: bold;
        color: #707070;
    }

    /* 线条运动 */
    @keyframes linearMotion {
        from {
            right: 150%;
        }

        to {
            right: -52%;
        }
    }

    @media(max-width: 1201px) {
        .text-box {
            width: 100%;
            height: 782px;
            display: grid;
            grid-template-columns: 90% 10%;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #ffffff;
            transition: all 0.5s;
        }
    }

    @media(max-width: 995px) {

        .marquee-text,
        .right-box,
        .animetionLine,
        .left-box::before {
            display: none;
        }

        .text-box {
            width: 100%;
            height: auto;
            display: grid;
            grid-template-columns: 1fr;
            position: static;
            left: 0%;
            bottom: 0%;
            background-color: #ffffff;
            transition: all 0.5s;
            transform: translate(0, 0%);
        }

        .marketing-box {
            height: auto;
        }

        .left-box {
            padding: 5%;
        }

        .left-center-box {
            max-width: 100%;
        }

        .title {
            font-size: 24px;
        }

        .caption {
            font-size: 24px;
            font-weight: 500;
            line-height: 125%;
            margin: 5% 0;
        }

        .showdown {
            font-size: 24px;
            line-height: 100%;
            -webkit-text-stroke: 1px rgba(112, 112, 112, 1);
            text-stroke: 1px rgba(112, 112, 112, 1);
            padding-left: 1%;
        }

        /* .right-box::after {
            display: none;
        }

        .marketing-box {
            height: auto;
        }

        .marquee-text {
            padding-top: 0px;
            padding-bottom: 50px;
        }

        .text-box {
            width: 90%;
            height: auto;
            display: grid;
            grid-template-columns: 1fr;
            position: absolute;
            left: 50%;
            bottom: 100%;
            background-color: #ffffff;
            transition: all 0.5s;
            transform: translate(-50%, 100%);
        }

        .caption {
            font-size: 24px;
            font-weight: 500;
            line-height: 125%;
            margin: 5% 0;
        }

        .showdown {
            font-size: 24px;
            line-height: 100%;
            -webkit-text-stroke: 1px rgba(112, 112, 112, 1);
            text-stroke: 1px rgba(112, 112, 112, 1);
            padding-left: 15px;
        }

        .left-box {
            padding: 5%;
        }

        .animetionLine,
        .left-box::before {
            display: none;
        } */
    }

    /* @media(max-width: 414px) {
        .marquee-text {
            padding-bottom: 100px;
        }
    }

    @media(max-width: 375px) {
        .marquee-text {
            padding-bottom: 120px;
        }
    }

    @media(max-width: 320px) {
        .marquee-text {
            padding-bottom: 170px;
        }
    } */

    /* @media(max-width: 1023px) {
        .marketing-box {
            height: 1300px;
        }

        .text-box {
            width: 100%;
            padding: 0% 5% 5%;
            grid-template-columns: 90% 10%;
            background-color: transparent;
            height: auto;
        }

        .animetionLine {
            display: none;
        }

        .left-center-box {
            max-width: 100%;
        }

        .left-box {
            background-color: rgba(255, 255, 255, .98);
        }

        .left-box::before {
            display: none;
        }

        .right-box {
            background-color: rgba(0, 0, 0, .1);
        }

        .title {
            font-size: 45px;
        }

        .caption {
            font-size: 94px;
            line-height: 117%;
        }

        .showdown {
            font-size: 94px;
            line-height: 150%;
            -webkit-text-stroke: 1px rgba(112, 112, 112, 1);
            text-stroke: 1px rgba(112, 112, 112, 1);
        }

        .chinese-box>>>p {
            font-size: 50px;
            line-height: 250%;
        }

        .english-box>>>p {
            font-size: 50px;
            line-height: 214%;
        }

        .right-box::after {
            top: 50%;
            left: 15%;
            font-size: 50px;
        }

        .right-box::before {
            background-color: rgba(0, 0, 0, .8);
        }
    }
    @media(max-width: 320px){
        .marketing-box {
            height: 1900px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/home/marketing.vue